import * as React from 'react';
import { classes, style } from 'typestyle';
import { Component, deps, inject } from '../../../lib/component';
import { observer } from 'mobx-react';
import { percent, px, url } from 'csx';
import { colorDarkBlueGrey, rebrand } from '../../../theme/color';
import LickdLogoGrey from '../../../static/lickd_logo_grey.svg';
import { Heart } from '../atoms/icons/Heart';
import { ButtonProminence } from '../atoms/button/buttonStyles';
import { CircleButton } from '../atoms/button/CircleButton';
import { borderRadius } from '../../../theme/border';

const backgroundColourStr = colorDarkBlueGrey.toHexString();

const styles = {
  wrapper: style({
    position: 'relative',
    paddingBottom: px(8),
  }),
  tile: style({
    background: 'center no-repeat',
    backgroundColor: rebrand.neutralOnDark[10].toString(),
    backgroundImage: url(LickdLogoGrey),
    borderRadius: borderRadius.MEDIUM,
    paddingBottom: percent(100),
  }),
  favouriteButton: style({
    position: 'absolute',
    top: px(8),
    right: px(8),
  }),
};

export type EmptyTileProps = { className?: string; tileClassName?: string };

@inject(deps)
@observer
export class EmptyTile extends Component<EmptyTileProps> {
  render() {
    const { className, tileClassName } = this.props;
    return (
      <div className={classes(styles.wrapper, className)}>
        <div className={classes(styles.tile, tileClassName)}>
          <CircleButton
            className={classes(styles.favouriteButton, 'empty-tile-favourite-btn')}
            prominence={ButtonProminence.SECONDARY}
            disabled
          >
            <Heart size={16} color={backgroundColourStr} />
          </CircleButton>
        </div>
      </div>
    );
  }
}
